// extracted by mini-css-extract-plugin
export default {"isPreRelease":"ServicePackVersionDetail_isPreRelease__6XCF2"};